import axios from 'axios';
import { postJobApiCall } from '../../utils/jobRequest';
import {
  VALIDATE_DYNAMIC_VOICE_CODE_FAILURE,
  VALIDATE_DYNAMIC_VOICE_CODE_REQUEST,
  VALIDATE_DYNAMIC_VOICE_CODE_SUCCESS,
  GET_TENANT_BRANDING,
} from '../Types/types';

// fetch tenant branding using the candidate-facing token from the invite link
export const fetchTenantBranding = (token) => async (dispatch) => {
  try {
    const baseUrl = (process.env.REACT_APP_AI_API_KEY || '').replace('/private/', '/');
    const response = await axios.get(`${baseUrl}tenant-branding/`, {
      params: { t: token },
      headers: {
        'x-api-key': process.env.REACT_APP_CANDIDATE_CHAT_API_KEY || '',
      },
    });
    if (response?.status === 200) {
      dispatch({ type: GET_TENANT_BRANDING, payload: response.data.data });
      return { success: true, data: response.data.data };
    }
    return { success: false };
  } catch (error) {
    console.error('Error fetching tenant branding:', error);
    return { success: false };
  }
};

export const validateDynamicVoiceCode = (voice_call_session_id, verification_code) => async (dispatch) => {
  dispatch({ type: VALIDATE_DYNAMIC_VOICE_CODE_REQUEST });
  try {
    const res = await postJobApiCall("dynamic-voice-call/validate-code", {
      voice_call_session_id,
      verification_code,
    });
    dispatch({ type: VALIDATE_DYNAMIC_VOICE_CODE_SUCCESS, payload: res.data.data });
    return { success: true };
  } catch (error) {
    dispatch({ type: VALIDATE_DYNAMIC_VOICE_CODE_FAILURE });
    const message =
      error?.response?.data?.detail ||
      error?.response?.data?.message ||
      (error?.response?.status === 403
        ? "Insufficient credits. Please contact your administrator."
        : "Invalid verification code or Insufficient credits. Please contact your administrator.");

    return { success: false, message };
  }
};
